import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/lib/config";

const NAV_LINKS = [
  { href: "#services", label: "Hizmetler" },
  { href: "#about", label: "Hakkımızda" },
  { href: "#appointment", label: "Randevu" },
  { href: "#reviews", label: "Yorumlar" },
  { href: "#contact", label: "İletişim" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-zinc-200"
          : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 lg:h-20">
        <a
          href="#top"
          className="flex items-center gap-2"
          data-testid="brand-logo-link"
        >
          <div className="w-9 h-9 bg-[#FF4500] flex items-center justify-center rounded-sm">
            <span className="text-white font-black text-lg">A</span>
          </div>
          <div className="leading-tight">
            <div className="font-black text-base sm:text-lg tracking-tight text-zinc-950">
              {BUSINESS.shortName}
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-semibold">
              Diyarbakır / Kayapınar
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-semibold text-zinc-700 hover:text-[#FF4500] transition-colors"
              data-testid={`nav-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden sm:flex items-center gap-3">
          <a href={`tel:${BUSINESS.phone1Tel}`} data-testid="header-call-btn">
            <Button className="bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-sm font-bold gap-2 h-10">
              <Phone className="w-4 h-4" />
              Hemen Ara
            </Button>
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-zinc-900"
          aria-label="Menüyü aç"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-zinc-200" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-zinc-800 py-2"
                data-testid={`mobile-nav-${l.href.slice(1)}`}
              >
                {l.label}
              </a>
            ))}
            <a href={`tel:${BUSINESS.phone1Tel}`} onClick={() => setOpen(false)}>
              <Button className="w-full bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-sm font-bold gap-2" data-testid="mobile-call-btn">
                <Phone className="w-4 h-4" /> {BUSINESS.phone1}
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
